// extracted by mini-css-extract-plugin
export default {"noResults":"bSQTkeIG_l_C8TAOBCuq","loadingResults":"zw1SHB3WKatq6kMRWEuQ"};